export const SELECT_TAB = 'SELECT_TAB';